import { ReactNode } from "react";
import { RoutePath } from "@src/interfaces/RoutePath";
import {
  IIntegration,
  IntegrationConfig,
  IntegrationType,
} from "@src/interfaces";

/**
 * Abstract base class for all integrations
 * Provides common functionality and enforces interface implementation
 */
export abstract class BaseIntegration implements IIntegration {
  abstract readonly type: IntegrationType;

  /**
   * Main render method that all integrations must implement
   */
  abstract render(tab: RoutePath): ReactNode;

  /**
   * Get the configuration for this integration
   */
  abstract getConfig(): IntegrationConfig;
}
